import { Link } from "react-router-dom";
import { Warning, Package, Ticket, ArrowRight, Headset } from "@phosphor-icons/react";

const CARDS = [
  {
    to: "/portail/nouveau",
    icon: Warning,
    iconClass: "bg-[#FDF2F2] text-[#C83B3B]",
    title: "Signaler un litige",
    subtitle: "Remboursement, livraison, produit endommagé… Ouvrez un ticket en quelques secondes.",
    testId: "portal-choice-new",
  },
  {
    to: "/portail/suivi?type=commande",
    icon: Package,
    iconClass: "bg-[#ECF9F1] text-[#218A49]",
    title: "Suivre une commande",
    subtitle: "Suivez vos commandes passées grâce à votre numéro de transaction ou votre lien de suivi.",
    testId: "portal-choice-order",
  },
  {
    to: "/portail/suivi?type=ticket",
    icon: Ticket,
    iconClass: "bg-[#E7F1EF] text-[#24593C]",
    title: "Suivre un ticket",
    subtitle: "Suivez un ticket déjà ouvert avec votre numéro de transaction ou le lien reçu par e-mail.",
    testId: "portal-choice-track",
  },
];

export default function Portal() {
  return (
    <section className="max-w-5xl mx-auto px-4 sm:px-6 pt-10 sm:pt-16" data-testid="portal-landing">
      {/* Hero */}
      <div className="mb-9 sm:mb-12 portal-fade-up">
        <div className="inline-flex items-center gap-2 rounded-full bg-white border border-black/[0.06] px-3 py-1 text-[12px] font-medium text-[#24593C] mb-5 shadow-sm">
          <span className="w-1.5 h-1.5 rounded-full bg-[#24593C]" />
          Ecocasse · Portail client
        </div>
        <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-[#1D211F] leading-[1.1] max-w-2xl">
          Bonjour 👋<br />Comment pouvons-nous vous aider&nbsp;?
        </h1>
        <p className="text-base sm:text-lg text-[#68706A] mt-4 max-w-xl">
          Choisissez une option ci-dessous. Aucune inscription n'est nécessaire.
        </p>
      </div>

      {/* Choice cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-5">
        {CARDS.map(({ to, icon: Icon, iconClass, title, subtitle, testId }, i) => (
          <Link
            key={testId}
            to={to}
            data-testid={testId}
            className="group portal-fade-up bg-white rounded-2xl border border-black/[0.05] shadow-[0_8px_30px_rgb(0,0,0,0.04)] p-6 flex flex-col hover:-translate-y-1 hover:shadow-[0_16px_44px_rgb(0,0,0,0.09)] transition-all duration-300"
            style={{ animationDelay: `${0.08 * (i + 1)}s` }}
          >
            <div className={`w-14 h-14 rounded-2xl flex items-center justify-center mb-5 ${iconClass}`}>
              <Icon size={28} weight="duotone" />
            </div>
            <h2 className="font-display text-xl font-semibold tracking-tight text-[#1D211F] mb-2">{title}</h2>
            <p className="text-[15px] text-[#68706A] leading-relaxed flex-1">{subtitle}</p>
            <div className="mt-5 inline-flex items-center gap-1.5 text-[15px] font-medium text-[#24593C]">
              Continuer
              <ArrowRight size={16} weight="bold" className="group-hover:translate-x-1 transition-transform duration-300" />
            </div>
          </Link>
        ))}
      </div>

      {/* Help banner */}
      <div className="mt-8 sm:mt-10 portal-fade-up rounded-2xl bg-[#24593C] text-white p-5 sm:p-6 flex items-start gap-4" style={{ animationDelay: "0.4s" }}>
        <div className="w-11 h-11 rounded-xl bg-white/15 flex items-center justify-center shrink-0">
          <Headset size={24} weight="duotone" />
        </div>
        <div>
          <div className="font-display font-semibold text-lg">Besoin d'aide immédiate&nbsp;?</div>
          <p className="text-[15px] text-white/80 mt-0.5">
            Appelez-nous au <a href="tel:+33388661707" className="font-semibold text-white underline underline-offset-2" data-testid="help-phone">03 88 66 17 07</a>, ou consultez vos e-mails Ecocasse pour retrouver votre lien de suivi.
          </p>
        </div>
      </div>
    </section>
  );
}
